import { useEffect, useRef } from 'react';
import './Contact.css';

import img1 from '../../assets/001.png';
import img2 from '../../assets/002.png';
import img3 from '../../assets/003.png';
import img4 from '../../assets/004.png';
import img5 from '../../assets/005.png';

const shoots = [
  { img: img1, cat: 'Classical Dance',   title: 'Grace of Bharatanatyam',  date: 'Apr 2025' },
  { img: img2, cat: 'Family Portrait',   title: 'Three Hearts, One Love',  date: 'Mar 2025' },
  { img: img3, cat: 'Bridal Portrait',   title: 'Draped in Elegance',      date: 'Jan 2025' },
  { img: img4, cat: 'Corporate Event',   title: 'Voices That Lead',        date: 'Mar 2025' },
  { img: img5, cat: 'Family Session',    title: 'Together We Smile',       date: 'Feb 2025' },
];

export default function RecentShoot() {
  const secRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) secRef.current?.classList.add('rs-visible'); },
      { threshold: 0.15 }
    );
    if (secRef.current) observer.observe(secRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="recent-shoot" className="rs-section" ref={secRef}>

      {/* Header */}
      <div className="rs-header">
        <p className="rs-eyebrow">Fresh From the Lens</p>
        <h2 className="rs-heading">
          Recent <em className="rs-italic-red">Shoots</em>
        </h2>
        <p className="rs-sub">A glimpse into our latest work — each frame a story told with light and emotion.</p>
      </div>

      {/* Grid */}
      <div className="rs-grid">
        {shoots.map((s, i) => (
          <div
            key={i}
            className={`rs-item rs-item-${i}`}
            style={{ '--delay': `${i * 0.1}s` }}
          >
            {/* Photo */}
            <div
              className="rs-img"
              style={{ backgroundImage: `url(${s.img})` }}
            />

            {/* Hover Overlay */}
            <div className="rs-overlay">
              <span className="rs-over-cat">{s.cat}</span>
              <h3 className="rs-over-title">{s.title}</h3>
              <p className="rs-over-meta">
                <span>{s.loc}</span>
                <span className="rs-over-sep">·</span>
                <span>{s.date}</span>
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="rs-footer">
        <a href="portfolio" className="rs-view-all">View All Work →</a>
      </div>

    </section>
  );
}